module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.turmas,
      "label": "Curso",
      "no-data-text": "Nenhum curso encontrado",
      "clearable": "",
      "return-object": "",
      "item-text": "descricao"
    },
    model: {
      value: (_vm.turma),
      callback: function($$v) {
        _vm.turma = $$v
      },
      expression: "turma"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.habilitarGeracaoBoletim) ? _c('empty-list', {
    attrs: {
      "title": "Selecione o Curso",
      "description": "Para habilitar a geração do boletim/parecer você precisa selecionar o curso"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "disabled": !_vm.habilitarGeracaoBoletim
    },
    on: {
      "click": function($event) {
        return _vm.gerarBoletim()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Gerar Boletim/Parecer")])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModalBoletim),
      callback: function($$v) {
        _vm.mostrarModalBoletim = $$v
      },
      expression: "mostrarModalBoletim"
    }
  }, [_c('v-card', {
    staticClass: "modal-pdf"
  }, [_c('v-card-text', [_c('iframe', {
    attrs: {
      "src": _vm.boletimBase64
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalBoletim = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61a235a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/academico/components/BoletinsPareceres.vue
// module id = 553
// module chunks = 2